import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { LookupCustomerRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { LookupCustomerResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const lookupCustomer = (request: LookupCustomerRequest, options?: CashRequestOptions) =>
  post<LookupCustomerRequest, LookupCustomerResponse>('/2.0/cash/lookup-customer', request, {
    ...options,
    rejectOnError: true,
  })
